// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { AccountAddress } from './account-address';
import { ActiveStatus } from './active-status';
import { JobOrder } from './job-order';
import { ProgramBillingConfig } from './program-billing-config';
import { Supplier } from './supplier';
import { SupplierSubmissionStatus } from './supplier-submission-status';
import { ActiveStatusEnum } from './enums';
import { SupplierSubmissionStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags
import { EntityPropertyAnnotation, EntityTypeAnnotation } from '../entity-type-annotations';
import { Validator } from 'breeze-client';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Manifest extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static getEntityTypeAnnotation(): EntityTypeAnnotation {
    const propAnnotations = [
      new EntityPropertyAnnotation('rRule', {
        displayName: 'Schedule',
      }),
      new EntityPropertyAnnotation('invoiceEmail', {
        validators: [BaseEntity.multipleEmailValidator],
      }),
    ];

    return new EntityTypeAnnotation({
      validators: [],
      propertyAnnotations: propAnnotations,
    });
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Guid FK account */
  accountId!: string;
  /** Enum FK activeStatus */
  activeStatusId!: ActiveStatusEnum;
  /** Guid FK billingAccountAddress */
  billingAccountAddressId!: string;
  /** String(100) */
  invoiceEmail?: string;
  /** String(100) */
  name!: string;
  /** String */
  portalName?: string;
  /** String(200) */
  rRule!: string;
  /** Binary */
  rowVersion!: any;
  /** Boolean */
  shouldIncludeInvoices!: boolean;
  /** Guid FK supplier */
  supplierId!: string;
  /** Enum FK supplierSubmissionStatus */
  supplierSubmissionStatusId!: SupplierSubmissionStatusEnum;
  /** FK accountId */
  account!: Account;
  /** FK activeStatusId */
  activeStatus!: ActiveStatus;
  /** FK billingAccountAddressId */
  billingAccountAddress!: AccountAddress;
  /** Inv FK manifestId */
  jobOrders!: JobOrder[];
  /** Inv FK manifestId */
  programBillingConfigs!: ProgramBillingConfig[];
  /** FK supplierId */
  supplier!: Supplier;
  /** FK supplierSubmissionStatusId */
  supplierSubmissionStatus!: SupplierSubmissionStatus;
}

